/**
 * 全局配置文件
 */
export default {
  baseUrl: "https://www.sz-sjh.cn"
}

export const baseUrl = "https://www.sz-sjh.cn";
